(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("learningItemTypeResource", ["$resource", learningItemTypeResource]);
    function learningItemTypeResource($resource) {
        return $resource("/api/learningItemTypes", {}, {
            query: {
                method: "GET",
                isArray: true,
                cache: true
            }
        });
    }
}());
